<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            placeholder="Tìm kiếm theo mã phiếu xuất (按批次代碼搜尋)" 
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.ID }}</td>
                <td>{{ item.PartnerName }}</td>
                <td class="text-end">{{ item.TotalPack | currency }}</td>
                <td class="text-end">{{ item.TotalSmallPack | currency }}</td>
                <td class="text-end">{{ item.TotalWeight | currency('', 2) }}</td>
                <td class="text-end">{{ item.TotalVolume | currency('', 3) }}</td>
                <td>{{ item.CreatedDate | display_date }}</td>
                <td>{{ item.CreatedBy }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" color="blue" @click="printPackage(item.ID)" data-toggle="tooltip" title="In tem">fa-print</v-icon>
                  <v-icon medium class="mr-2" @click="deleteItem(item.ID)" v-if="adminRole" data-toggle="tooltip" title="Xoá phiếu">fa-trash-alt</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { display_color } from "@/commons/formater";
import _ from "lodash";
import { print_export_bigpackage } from '@/commons/hpod';

export default {
  components: {
    "hpo-filter": Filtering,
  },
  props: ["dashboard_pagination"],
  data() {    
    return {      
      display_color: display_color,
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "bigexport_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
  },
  computed: {
    ...mapState({
      items: state => state.bigExport.all.data,
      total_rows: state => state.bigExport.all.total,
      currentItem: state => state.bigExport.selected,
      loading: state => state.bigExport.loading
    }),
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
    param() {
      return {
        pagination: this.dashboard_pagination ? this.dashboard_pagination : this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
    },
    headers() {
      let dataType = configs.DATA_TYPE;
      let header_admin = [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          quickSearch: true,
          width: 150,
          dataType: dataType["Number"]
        },
        {
          text: "Đối tác VC (承運商)",
          value: "Status",
          filterable: true,
          uickSearch: true,
          dataType: dataType["String"],
          width: 100
        },
        {
          text: "Tổng mã (代碼總數)",
          value: "TotalPack",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng kiện (總包數)",
          value: "TotalSmallPack",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng cân (總重量)",
          value: "TotalWeight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng khối (總容積)",
          value: "TotalVolume",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ngày tạo (創建日期)",
          value: "CreatedDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Người tạo (創作者)",
          value: "CreatedBy",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác (手術)",
          value: "",
          align: "center",
          width: "150px"
        }
      ];
      return header_admin;
    }
  },
  methods: {
    filter_data: function() {
      this.$store.dispatch("bigExport/getList", this.param);
    },
    printPackage(id) {
      this.$store.dispatch("bigExport/getDetail", id).then(p => {
          const frame_printing = print_export_bigpackage(p.ID, p.PartnerName, p.TotalPack, p.TotalSmallPack, p.TotalWeight, p.TotalVolume, p.BigPackages);
          var doc = document.getElementById('print_frame').contentWindow.document;
          doc.open();
          doc.write(frame_printing);
          doc.close();
          setTimeout(function () { window.frames["print_frame"].window.print(); }, 1000);
        });
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("bigExport/removeDetail", id);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA");
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
